export const ADD_MENU_ITEM = '@AdminPanel/ADD_MENU_ITEM';
export const UPDATE_MENU_ITEM = '@AdminPanel/UPDATE_MENU_ITEM';
export const REMOVE_MENU_ITEM = '@AdminPanel/REMOVE_MENU_ITEM';